import { TransitionMap } from '../types';
import { collapsedStyles } from '../consts';

export const createTransitionMap = ({
  desktopDefaultStyles,
  mobileDefaultStyles,
  desktopSupportWindowStyles,
  mobileSupportWindowStyles,
}: {
  desktopDefaultStyles: Record<string, unknown>;
  mobileDefaultStyles: Record<string, unknown>;
  desktopSupportWindowStyles: Record<string, unknown>;
  mobileSupportWindowStyles: Record<string, unknown>;
}): TransitionMap => {
  return {
    FAB: {
      hide: {
        startTransitionMessageType: { type: 'hide-fab' },
        completeTransitionMessageType: { type: 'hide-fab-transition-complete' },
      },
      FAC: {
        show: {
          startTransitionMessageType: { type: 'show-fac' },
          completeTransitionMessageType: { type: 'show-fac-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
      },
      FAB_TO_FAC: {
        show: {
          startTransitionMessageType: { type: 'show-fab-to-fac' },
          completeTransitionMessageType: { type: 'show-fab-to-fac-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
      },
      WINDOW: {
        show: {
          startTransitionMessageType: { type: 'show-support-window' },
          completeTransitionMessageType: { type: 'show-support-window-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
      },
      HIDDEN: {
        show: {
          startTransitionMessageType: { type: 'show-hidden' },
          completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
        },
        styles: () => ({ display: 'none' }),
      },
    },
    FAC: {
      hide: {
        startTransitionMessageType: { type: 'hide-fac' },
        completeTransitionMessageType: { type: 'hide-fac-transition-complete' },
      },
      FAB: {
        show: {
          startTransitionMessageType: { type: 'show-fab' },
          completeTransitionMessageType: { type: 'show-fab-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
          ...collapsedStyles,
        }),
      },
      FAB_TO_FAC: {
        show: {
          startTransitionMessageType: { type: 'show-fab-to-fac' },
          completeTransitionMessageType: { type: 'show-fab-to-fac-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
      },
      WINDOW: {
        show: {
          startTransitionMessageType: { type: 'show-support-window' },
          completeTransitionMessageType: { type: 'show-support-window-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
      },
      HIDDEN: {
        show: {
          startTransitionMessageType: { type: 'show-hidden' },
          completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
        },
        styles: () => ({ display: 'none' }),
      },
    },
    FAB_TO_FAC: {
      hide: {
        startTransitionMessageType: { type: 'hide-fab-to-fac' },
        completeTransitionMessageType: { type: 'hide-fab-to-fac-transition-complete' },
      },
      FAB: {
        show: {
          startTransitionMessageType: { type: 'show-fab' },
          completeTransitionMessageType: { type: 'show-fab-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
          ...collapsedStyles,
        }),
      },
      FAC: {
        show: {
          startTransitionMessageType: { type: 'show-fac' },
          completeTransitionMessageType: { type: 'show-fac-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
      },
      WINDOW: {
        show: {
          startTransitionMessageType: { type: 'show-support-window' },
          completeTransitionMessageType: { type: 'show-support-window-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
      },
      HIDDEN: {
        show: {
          startTransitionMessageType: { type: 'show-hidden' },
          completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
        },
        styles: () => ({ display: 'none' }),
      },
    },
    WINDOW: {
      hide: {
        startTransitionMessageType: { type: 'hide-support-window' },
        completeTransitionMessageType: { type: 'hide-support-window-transition-complete' },
      },
      FAB: {
        show: {
          startTransitionMessageType: { type: 'show-fab' },
          completeTransitionMessageType: { type: 'show-fab-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
          ...collapsedStyles,
        }),
      },
      FAB_TO_FAC: {
        show: {
          startTransitionMessageType: { type: 'show-fab-to-fac' },
          completeTransitionMessageType: { type: 'show-fab-to-fac-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
      },
      FAC: {
        show: {
          startTransitionMessageType: { type: 'show-fac' },
          completeTransitionMessageType: { type: 'show-fac-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
      },
      HIDDEN: {
        show: {
          startTransitionMessageType: { type: 'show-hidden' },
          completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
        },
        styles: () => ({ display: 'none' }),
      },
    },
    HIDDEN: {
      hide: {
        startTransitionMessageType: { type: 'show-hidden' },
        completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
      },
      FAB: {
        show: {
          startTransitionMessageType: { type: 'show-fab' },
          completeTransitionMessageType: { type: 'show-fab-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
          ...collapsedStyles,
        }),
      },
      FAB_TO_FAC: {
        show: {
          startTransitionMessageType: { type: 'show-fab-to-fac' },
          completeTransitionMessageType: { type: 'show-fab-to-fac-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
      },
      FAC: {
        show: {
          startTransitionMessageType: { type: 'show-fac' },
          completeTransitionMessageType: { type: 'show-fac-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
      },
      WINDOW: {
        show: {
          startTransitionMessageType: { type: 'show-support-window' },
          completeTransitionMessageType: { type: 'show-support-window-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
      },
    },
  };
};
